








































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAuthService } from '@/auth';

@Component
export default class HeaderDesktop extends Vue {

  private $auth: any = (this as any).$auth;

  private authService = getAuthService();

  private login() {
    this.authService.loginWithRedirect();
  }

  private logout() {
    this.authService.logout({
      returnTo: window.location.origin,
    });
  }

}
